export const FEEDBACK_ACCEPTED_FILE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
];

export const FEEDBACK_MAX_FILE_SIZE = 5 * 1024 * 1024;
